module.exports = __webpack_public_path__ + "img/historical.01a59c9e.svg";